/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

import { Link, THEME_CONSTANTS } from '@cof/plastic-components';

import pushToDataLayer, { EVENTS } from '../../utilities/dataLayer';

const { FONT_WEIGHTS } = THEME_CONSTANTS;

// @ts-expect-error TS2339: Property 'children' does not exist on type ''.
const ModalLink = React.forwardRef(({ children, modalName, onClick, ...props }, ref) => {
    const handleClick = (event: any) => {
        if (event) {
            event.preventDefault();
        }
        if (modalName) {
            pushToDataLayer({
                event: EVENTS.MODAL_OPEN,
                modalName
            });
        }
        onClick(event);
    };
    return (
        // @ts-expect-error TS2322: Type 'ForwardedRef<unknown>' is not assignable to type 'Ref<HTMLAnchorElement> | undefined'.
        <Link isModalLink fontWeight={FONT_WEIGHTS.SB} href="#" ref={ref} onClick={handleClick} {...props}>
            {children}
        </Link>
    );
});

ModalLink.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    modalName: PropTypes.string
};

ModalLink.displayName = 'ModalLink';

export default ModalLink;
